module.exports = __webpack_public_path__ + "static/media/filterTable.5a8cd5c4.svg";